module.exports = __webpack_public_path__ + "media/images/avatar-d0f4d81b2c688f8c36e3964360c4bf21.jpg";